<script setup>
import FooterBar from "@/components/FooterBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
// import NoticiasCard from "@/components/NoticiasCard.vue";
import router from "@/router";
import { onMounted, ref, watch } from "vue";

watch(() => {
  noticia;
});

const noticia_id = ref(null);
const noticia = ref(null);


onMounted(() => {
  noticia_id.value = router.currentRoute.value.params.id;

  if (noticia_id.value) {
    noticia.value = getNewsByID(`https://vituz.app/api/noticias-site/${noticia_id?.value}`);
  };
});

async function getNewsByID(url) {
  const axios = require("axios").default;
  return axios
    .get(url)
    .then(function (response) {
      noticia.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
}

const backToNews = () => {
  router.push({ name: "NoticiasView" });
};
</script>

<template>
  <NavigationBar />
  <body class="mt-0 md:mt-32">
    <div v-if="noticia" class="flex-col px-4 mx-auto text-center md:text-sm md:w-7/12 md:px-0">
        <div class="mt-20 text-left md:mt-44">
          <p class="text-xl md:text-3xl">{{ noticia?.titulo }}</p>
        </div>

        <div class="flex flex-col-reverse mt-4 md:flex md:flex-row md:mt-0">
          <div v-html="noticia?.conteudo" class="w-full mt-10 mr-5 text-justify md:text-left sm:w-1/2 text-md"></div>
          <div class="flex-col w-full sm:w-1/2 md:mt-10 md:flex">
            <div class="w-full">
              <img
                :src="noticia?.image"
                alt="foto"
                class="object-cover rounded-md"
              />
              
            </div>
            <div class="flex justify-end my-2">
              <span class="p-1 text-xs rounded-md bg-igep-blue bg-opacity-20">
                {{ noticia?.autor }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex justify-end my-5">
          <button
            :href="noticia?.link"
            @click="backToNews"
            class="flex p-2 text-xs bg-gray-200 rounded-lg md:text-sm"
          >
            <img src="https://cdn-icons-png.flaticon.com/128/709/709624.png" alt="Voltar" class="w-4 h-4 mr-2" />
            Voltar
          </button>
        </div>
      </div>
  </body>
  <FooterBar />
</template>
